import PropTypes from "prop-types";
import { useState } from "react";

// Password field with its show/hide eye, shared by the login form and the new
// password form. Styles are .lg-input-wrap / .lg-eye in landing.scss.
export const PasswordInput = ({ id, name, value, onChange, autoComplete }) => {
  const [shown, setShown] = useState(false);

  return (
    <div className="lg-input-wrap">
      <input
        id={id}
        name={name}
        type={shown ? "text" : "password"}
        placeholder="••••••••"
        onChange={onChange}
        value={value}
        autoComplete={autoComplete}
        required
      />
      <button
        type="button"
        className="lg-eye"
        onClick={() => setShown(!shown)}
        aria-label={shown ? "Hide password" : "Show password"}
        aria-pressed={shown}
      >
        <i className={"fa-solid " + (shown ? "fa-eye-slash" : "fa-eye")} />
      </button>
    </div>
  );
};

PasswordInput.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  autoComplete: PropTypes.string.isRequired,
};
